// External props

import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

// Internal props
import './Day.scss';
import { certificationServiceStatus } from '../../../../../constants/constants';
import { formatFullDate, formatsEnum } from '../../../../../utils/formatUtils';
import { workReportLineStatus } from '../../../../../utils/dataStatus';

const Day = ({
  variant,
  day,
  rowIdx,
  arrayDate,
  minDate,
  maxDate,
  isSummaryModal,
  lineBlockedBySap
}) => {
  const isLastDayPrevMonth = rowIdx === 0 && Number(day.format('D')) > 7;
  const isDayNextMonth = (rowIdx === 4 || rowIdx === 5) && Number(day.format('D')) <= 14;
  const isOtherDay = isLastDayPrevMonth || isDayNextMonth;
  const dayFormat = day.format(formatsEnum.FORMAT_DATE_4);
  const filteredLine = arrayDate.find((opt) => formatFullDate(opt.fecha) === dayFormat);

  const isAprovedOrFixed =
    filteredLine?.estadoEnum === workReportLineStatus.aprobar ||
    filteredLine?.estadoEnum === workReportLineStatus.fijar;

  const lineIsWhitAlert =
    filteredLine?.estadoRevision?.estadoCertEnum === certificationServiceStatus.wrong &&
    isAprovedOrFixed;

  const lineIsRejected =
    filteredLine?.estadoRevision?.estadoCertEnum === certificationServiceStatus.reject &&
    isAprovedOrFixed;

  const lineIsAuthorized =
    filteredLine?.estadoRevision?.estadoCertEnum === certificationServiceStatus.approve &&
    isAprovedOrFixed;

  const lineIsExpertReview = filteredLine?.estadoRevision?.revisionExperta && isAprovedOrFixed;

  const isDateOutOfRange = (dayFormatDate, minDateValue, maxDateValue) => {
    if (minDateValue) {
      const minFormatDate = new Date(formatFullDate(minDate, formatsEnum.FORMAT_DATE_2));

      if (dayFormatDate < minFormatDate) {
        return true;
      }
    }

    if (maxDateValue) {
      const maxFormatDate = new Date(formatFullDate(maxDateValue, formatsEnum.FORMAT_DATE_2));

      if (dayFormatDate > maxFormatDate) {
        return true;
      }
    }

    return false;
  };

  const getStyleForDay = (isSomeDay, isOtherDayValue, arrayDateValue, formatDay, isCircle) => {
    let style = '';

    if (isSomeDay && !isOtherDayValue) {
      const findDay = arrayDateValue.find((opt) => formatFullDate(opt.fecha) === formatDay);

      style = findDay.variant;
    }

    if (style && !isCircle) {
      style = `day-${style}`;
    }

    return style;
  };

  const addCertificationStyles = (
    style,
    lineIsWhitAlertValue,
    lineIsRejectedValue,
    lineIsExpertReviewValue,
    lineIsAuthorizedValue
  ) => {
    let styleCopy = style;

    if (lineIsWhitAlertValue) {
      styleCopy = `${style} certification-error`;
    }

    if (lineIsRejectedValue) {
      styleCopy = `${style} certification-rejected`;
    }

    if (lineIsExpertReviewValue) {
      styleCopy = `${style} certification-expert-review`;
    }

    if (lineIsAuthorizedValue) {
      styleCopy = `${style} certification-autorizada`;
    }

    return styleCopy;
  };

  const validStyleDay = (isCircle = false) => {
    const formatDay = day.format(formatsEnum.FORMAT_DATE_4);
    const dayFormatToCompare = day.format(formatsEnum.FORMAT_DATE_2);
    const dayFormatDate = new Date(dayFormatToCompare);

    if (minDate || maxDate) {
      if (isDateOutOfRange(dayFormatDate, minDate, maxDate)) {
        return 'day-shadow';
      }
    }

    const isSomeDay = arrayDate.some((opt) => formatFullDate(opt.fecha) === formatDay);
    let style = getStyleForDay(isSomeDay, isOtherDay, arrayDate, formatDay, isCircle);

    style = addCertificationStyles(
      style,
      lineIsWhitAlert,
      lineIsRejected,
      lineIsExpertReview,
      lineIsAuthorized
    );

    return style;
  };

  const renderTooltip = (propsTooltip) => {
    const formatDay = day.format('DD/MM/YYYY');
    const quantity = arrayDate.find((opt) => formatFullDate(opt.fecha) === formatDay);

    if (lineBlockedBySap) {
      return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Tooltip {...propsTooltip} show>
          <span>Inactiva por SAP</span>
        </Tooltip>
      );
    }

    if (isSummaryModal) {
      return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Tooltip id={`day-${quantity.variant}-tooltip`} {...propsTooltip} show>
          <span>{quantity && quantity.cantReg}</span>
        </Tooltip>
      );
    }

    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <Tooltip id={`day-${quantity.variant}-tooltip`} {...propsTooltip} show>
        <span>{quantity && quantity.cantidad}</span>
      </Tooltip>
    );
  };

  const renderDayComponent = () => (
    <div
      aria-hidden
      // style={colors}
      className={`day ${isOtherDay ? 'day-shadow' : `day-${variant}`} ${validStyleDay()}`}
      // onClick={isOtherDay || validStyleDay() === 'day-shadow' ? () => {} : () => onClickDay(day)}
    >
      {isOtherDay ? null : (
        <>
          <div className="day-number">{day.format('D')}</div>
          <div className="content-circle">
            <div className={`circle ${variant} ${validStyleDay(true)}`} />
          </div>
        </>
      )}
    </div>
  );

  return (
    <div>
      {rowIdx === 0 && <div className="text-center">{day.format('ddd').toUpperCase()}</div>}
      {(validStyleDay() && validStyleDay() !== 'day-shadow') || lineBlockedBySap ? (
        <OverlayTrigger
          delay={{
            show: 250,
            hide: 400
          }}
          overlay={renderTooltip}
          placement="top"
        >
          {renderDayComponent()}
        </OverlayTrigger>
      ) : (
        <>{renderDayComponent()}</>
      )}
    </div>
  );
};

Day.propTypes = {
  variant: PropTypes.string,
  day: PropTypes.objectOf(PropTypes.shape).isRequired,
  rowIdx: PropTypes.number.isRequired,
  arrayDate: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  // onClickDay: PropTypes.func.isRequired,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  isSummaryModal: PropTypes.bool,
  lineBlockedBySap: PropTypes.bool.isRequired
};

Day.defaultProps = {
  variant: '',
  arrayDate: [],
  minDate: '',
  maxDate: '',
  isSummaryModal: false
};

export default Day;
